import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";

const Row = ({ k, v }) => <div className="flex justify-between gap-3 py-1.5 border-b border-white/5 text-sm"><span className="text-slate-400">{k}</span><span className="text-white text-right">{v}</span></div>;

export function ConfirmAssign({ s, onCancel, onConfirm }) {
  const [busy, setBusy] = useState(false);
  return (
    <Dialog open onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-md bg-[#070B14] border-[#D4A72C]/30 text-slate-200" data-testid="nx-confirm-assign">
        <DialogHeader><DialogTitle className="font-display text-xl text-white">Confermi l'assegnazione proposta?</DialogTitle></DialogHeader>
        <Row k="Servizio" v={`${s.time || ""} · ${s.pickup || ""} → ${s.destination || ""}`} />
        <Row k="Passeggeri" v={s.passengers} />
        <Row k="Autista" v={`${s.driver_name}${s.shift ? ` (turno ${s.shift === "NIGHT" ? "notte" : "giorno"})` : ""}`} />
        <Row k="Veicolo" v={s.plate ? `${s.vehicle_label} · ${s.plate}` : "Nessun veicolo libero adatto: da scegliere"} />
        <p className="text-[11px] text-slate-500">Proposta calcolata a regole: autista di turno (nell'orario del turno, se indicato) senza servizi sovrapposti e veicolo disponibile con posti sufficienti. Il prezzo cliente non cambia; compenso autista e margine vengono ricalcolati con le regole esistenti, come per un'assegnazione manuale. Lo stato della prenotazione resta invariato.</p>
        <div className="grid grid-cols-2 gap-3 mt-2">
          <button type="button" onClick={onCancel} className="h-10 rounded-xl border border-white/15 hover:bg-white/5" data-testid="nx-confirm-cancel">Annulla</button>
          <button type="button" disabled={busy} onClick={async () => { setBusy(true); await onConfirm(); setBusy(false); }} className="h-10 rounded-xl btn-gold-primary font-bold disabled:opacity-50" data-testid="nx-confirm-ok">Conferma</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
